import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MsalInterceptor } from '@azure/msal-angular';
import { BYPASS_MSAL } from './bypass-msal.token';

@Injectable()
export class MsalSkipInterceptor extends MsalInterceptor implements HttpInterceptor {
  override intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(BYPASS_MSAL)) {
      return next.handle(request);
    }
    return super.intercept(request, next);
  }
}
